module.exports = __webpack_public_path__ + "static/icons_startseite_einzelhandel-08d2750260e80838f0fcc9e9e43d3177.png";